export const emptySettings: () => JsspSettings = () => <JsspSettings>{}

export interface JsspSettings {
  id: string
  facility: string
  maxPackageWeightKg: number
  productionMinuteCost: number
  involvedWcCost: number
  involvedPackageCost: number
  unequalDistributionCost: number
}
